{
  "heading": "Collection",
  "tabs": {
    "label": "Vues de la collection",
    "cards": "Cartes",
    "animes": "Œuvres"
  },
  "media": {
    "anime": "Anime",
    "manga": "Manga",
    "novel": "Roman",
    "videoGame": "Jeu vidéo",
    "cinematography": "Cinématographie",
    "work": "Œuvre"
  },
  "filters": {
    "title": "Filtres",
    "button": "Filtres",
    "reset": "Réinitialiser",
    "sort": "Trier",
    "sortBy": "Trier par",
    "display": "Affichage",
    "all": "Tous",
    "show": "Afficher"
  },
  "binder": {
    "search": "Rechercher un personnage, un titre ou une étiquette",
    "purge": "Purge",
    "purgeCards": "Purger des cartes",
    "fragments": "Fragments",
    "fragmentsCards": "Améliorer des cartes",
    "favoritesOnly": "Favoris uniquement",
    "wishFailed": "Souhait impossible à mettre à jour",
    "showCards": "Voir les cartes",
    "openBooster": "Ouvrir un booster",
    "noMatch": "Aucune carte ne correspond",
    "noMatchHint": "Modifie la recherche ou les filtres.",
    "empty": "Ton classeur est vide",
    "missingHint": "Les personnages manquants apparaissent en silhouette sur la page de chaque <anime>œuvre</anime>.",
    "summary": "{{characters}}, {{fragments}}, {{animes}}.",
    "characters_one": "{{formatted}} personnage",
    "characters_other": "{{formatted}} personnages",
    "characters_many": "{{formatted}} personnages",
    "fragments_one": "{{formatted}} fragment en réserve",
    "fragments_other": "{{formatted}} fragments en réserve",
    "fragments_many": "{{formatted}} fragments en réserve",
    "animes_one": "{{formatted}} œuvre complétée",
    "animes_other": "{{formatted}} œuvres complétées",
    "animes_many": "{{formatted}} œuvres complétées",
    "sorts": {
      "recent": "Obtenus récemment",
      "popularity": "Popularité",
      "nametag": "Étiquette",
      "rarity": "Rareté",
      "fragments": "Fragments",
      "level": "Niveau",
      "name": "Nom",
      "attack_desc": "Attaque (forte → faible)",
      "attack_asc": "Attaque (faible → forte)",
      "defense_desc": "Défense (forte → faible)",
      "defense_asc": "Défense (faible → forte)"
    }
  },
  "animes": {
    "intro": "Le rang dépend de la popularité de l’œuvre, de F à EX. Complète une série en obtenant tous ses personnages.",
    "searchPlaceholder": "Rechercher une œuvre",
    "searchLabel": "Rechercher une œuvre",
    "rankFilter": "Filtrer par rang",
    "allRanks": "Tous les rangs",
    "rank": "Rang",
    "rankOption": "Rang {{rank}}",
    "showAnimes": "Voir les œuvres",
    "progress": "Progression {{title}}",
    "emptyTitle": "Aucune œuvre trouvée",
    "emptyBody": "Le catalogue se remplit au fil de la synchronisation.",
    "emptyFilteredTitle": "Rien ici pour le moment",
    "emptyFilteredBody": "Ouvre des boosters pour commencer des séries.",
    "views": {
      "all": "Tous",
      "owned": "Commencés",
      "completed": "Complétés"
    },
    "sorts": {
      "popularity": "Popularité",
      "progress": "Progression",
      "title": "Titre",
      "characters": "Plus de personnages",
      "divine": "Plus de Divines",
      "mythic": "Plus de Mythiques",
      "legendary": "Plus de Légendaires",
      "epic": "Plus d’Épiques",
      "rare": "Plus de Rares",
      "uncommon": "Plus de Peu-Communs",
      "common": "Plus de Communs"
    }
  },
  "series": {
    "back": "Œuvres",
    "cover": "couverture",
    "banner": "bannière",
    "progress": "Progression de la série",
    "complete": "Série complète",
    "rewards": {
      "title": "Récompense de complétion",
      "booster": "{{charges}} × {{name}}",
      "earned": "Déjà récupérée"
    },
    "shown": "Personnages affichés",
    "favourites_one": "{{formatted}} favori",
    "favourites_other": "{{formatted}} favoris",
    "favourites_many": "{{formatted}} favoris",
    "obtained_one": "{{owned}} / {{total}} personnage obtenu",
    "obtained_other": "{{owned}} / {{total}} personnages obtenus",
    "obtained_many": "{{owned}} / {{total}} personnages obtenus",
    "sort": "Trier",
    "sorts": {
      "rarity": "Rareté",
      "attack_desc": "Attaque (forte → faible)",
      "attack_asc": "Attaque (faible → forte)",
      "defense_desc": "Défense (forte → faible)",
      "defense_asc": "Défense (faible → forte)"
    },
    "show": {
      "all": "Tous",
      "owned": "Obtenus",
      "missing": "Manquants"
    },
    "noMissing": "Aucun personnage manquant",
    "noMissingHint": "Tu as complété cette série.",
    "noneOwned": "Aucun personnage obtenu",
    "noneOwnedHint": "Les boosters peuvent contenir les personnages de cette série.",
    "favoriteFailed": "Favori impossible",
    "wishFailed": "Souhait impossible"
  },
  "purge": {
    "actions": "Vente des cartes sélectionnées",
    "selected_one": "{{count}} carte",
    "selected_other": "{{count}} cartes",
    "title": "Purge",
    "intro": "Le système reprend les cartes à 10 % de leur valeur. 5 % de cette somme vont dans la cagnotte. Touche l’étoile pour garder un personnage : un favori ne peut pas être vendu.",
    "rarityGroup": "Purger une rareté entière",
    "search": "Rechercher un personnage ou un titre",
    "empty": "Aucune carte à purger",
    "emptyHint": "Les favoris et les cartes verrouillées restent dans ta collection.",
    "tooLow": "Trop faible",
    "selling": "Vente…",
    "sell": "Vendre au système",
    "rarityFailed": "Rareté indisponible",
    "none": "Aucun {{rarity}} à purger",
    "noneHint": "Les favoris et les cartes verrouillées restent.",
    "favoriteFailed": "Favori impossible",
    "sold": "Purge vendue",
    "failed": "Purge impossible",
    "confirm": "Vendre au système {{cards}} pour {{anima}} ? Elles quittent ta collection. Les favoris restent.",
    "soldDetail": "{{cards}} · {{anima}}",
    "cards_one": "{{formatted}} carte",
    "cards_other": "{{formatted}} cartes",
    "cards_many": "{{formatted}} cartes",
    "anima": "{{formatted}} Anima"
  },
  "fragments": {
    "actions": "Amélioration et conversion des fragments",
    "title": "Fragments",
    "intro": "10 niveaux pour créer une carte à ton image. Chaque amélioration débloque une personnalisation et de nouveaux reflets. Sélectionne tes cartes pour les améliorer d’un niveau.",
    "levelGuide": "Les niveaux ouvrent l’atelier",
    "levelGuideHint": "Ouvre la fiche d’une carte pour essayer ses paliers et personnaliser les options débloquées.",
    "conversionHint": "Seuls les fragments des cartes au niveau 10 peuvent être convertis en Anima. Ceux des anciens niveaux 5 restent disponibles pour les nouveaux paliers.",
    "search": "Rechercher un personnage ou un titre",
    "rarity": "Filtrer par rareté",
    "allRarities": "Toutes les raretés",
    "selectPage": "Tout sélectionner",
    "empty": "Aucune carte à améliorer",
    "emptyHint": "Ouvre des boosters et recycle tes doublons pour gagner des fragments.",
    "step": "Nv {{level}} · {{fragments}}",
    "notEnough": "Fragments insuffisants",
    "maxed": "Éveillée · 10/10",
    "convertValue": "+{{anima}} Anima",
    "convertSpare": "Convertir les fragments inutiles en Anima",
    "converting": "Conversion…",
    "confirmConvert": "Fondre en Anima les fragments de toutes les cartes au niveau maximum ?",
    "converted": "Fragments fondus",
    "convertedDetail": "{{cards}} cartes vidées : {{fragments}} fragments → {{anima}} Anima.",
    "stashTitle": "Fragments en réserve",
    "stashTotal": "{{fragments}} en attente",
    "stashIntro": "Gagnés par des quêtes, des succès ou des ventes : ils rejoignent la carte dès que tu obtiens le personnage.",
    "stashEmpty": "Aucun fragment en réserve pour le moment.",
    "stashCount": "{{fragments}} fragments",
    "stashTruncated": "{{entries}} autres personnages ont aussi des fragments en réserve.",
    "upgraded": "Améliorations appliquées",
    "upgradedDetail": "{{cards}} cartes améliorées, {{fragments}} fragments dépensés.",
    "failed": "Amélioration impossible",
    "upgrading": "Amélioration…",
    "upgradeSelection": "Améliorer ({{cards}})",
    "upgradeAll": "Tout améliorer",
    "confirmSelection": "Améliorer {{cards}} carte(s) d’un niveau ?",
    "confirmAll": "Améliorer d’un niveau toutes les cartes qui peuvent l’être ?"
  },
  "detail": {
    "fallbackTitle": "Carte",
    "upgraded": "Carte améliorée au niveau {{level}}",
    "unlocked": "Débloqué : {{unlock}}",
    "upgradeFailed": "Amélioration impossible",
    "favourites": "Favoris",
    "referenceValue": "Valeur de référence",
    "attack": "Attaque",
    "defense": "Défense",
    "role": "Rôle",
    "obtainedOn": "Obtenu le",
    "copies": "Exemplaires obtenus",
    "lock": "Verrouillage",
    "locks": {
      "listing": "En vente",
      "auction": "En enchère",
      "trade": "En échange"
    },
    "stashed": "Fragments mis de côté",
    "upgrade": "Amélioration",
    "levelOf": "Niveau {{level}} sur {{max}}",
    "fragmentMeter": "Fragments pour la prochaine amélioration",
    "fragmentCount_one": "{{owned}} / {{cost}} fragment",
    "fragmentCount_other": "{{owned}} / {{cost}} fragments",
    "fragmentCount_many": "{{owned}} / {{cost}} fragments",
    "upgradeHint": "Débloque : {{unlock}}. Chaque doublon {{rarity}} rapporte {{fragments}}.",
    "fragmentYield_one": "{{count}} fragment",
    "fragmentYield_other": "{{count}} fragments",
    "fragmentYield_many": "{{count}} fragments",
    "maxReached": "Carte éveillée : les 9 personnalisations sont disponibles.",
    "missing": "Pas encore dans ta collection. Ce personnage {{rarity}} peut sortir de n’importe quel booster proposant cette rareté.",
    "removeFavorite": "Retirer des favoris",
    "addFavorite": "Ajouter aux favoris",
    "favoriteFailed": "Favori impossible",
    "addWish": "Ajouter aux souhaits",
    "removeWish": "Retirer des souhaits",
    "wishHint": "Tu seras prévenu s’il est mis en vente ou aux enchères.",
    "wishFailed": "Souhait impossible à mettre à jour",
    "nametag": "Étiquette personnelle",
    "nametagPlaceholder": "Ex. JOJO",
    "nametagHint": "La même étiquette peut regrouper plusieurs personnages.",
    "saveNametag": "Enregistrer",
    "nametagSaved": "Étiquette mise à jour",
    "nametagFailed": "Étiquette impossible à mettre à jour",
    "avatarUpdated": "Avatar mis à jour",
    "useAvatar": "Utiliser comme avatar",
    "share": "Partager",
    "linkCopied": "Lien copié",
    "copyLink": "Copier le lien public",
    "sell": "Vendre",
    "upgradeTo": "Améliorer au niveau {{level}}"
  },
  "workshop": {
    "title": "Atelier de carte",
    "cardInfo": "Informations sur la carte",
    "evolution": "Évolution",
    "customize": "Personnaliser",
    "levels": "Les 10 niveaux de la carte",
    "previewHint": "Touche un niveau pour essayer son rendu, sans dépenser de fragments.",
    "previewLevel": "Aperçu du niveau {{level}} · non appliqué",
    "backToCard": "Revenir à ma carte",
    "unsaved": "Personnalisation non enregistrée",
    "reached": "Débloqué",
    "notReached": "À débloquer",
    "next": "Prochain palier",
    "previewOnly": "Aperçu uniquement",
    "stepCost": "{{cost}} fragments depuis le niveau précédent",
    "costShort": "{{cost}} fragments",
    "nextUpgrade": "Prochaine amélioration · niveau {{level}}",
    "useUnlock": "Utiliser cette option",
    "allUnlocks": "Voir les 10 paliers",
    "ready": "Tout est prêt pour passer au niveau suivant.",
    "remaining_one": "Encore {{formatted}} fragment pour ce palier.",
    "remaining_other": "Encore {{formatted}} fragments pour ce palier.",
    "remaining_many": "Encore {{formatted}} fragments pour ce palier.",
    "duplicateYield_one": "Chaque doublon rapporte {{count}} fragment à cette carte.",
    "duplicateYield_other": "Chaque doublon rapporte {{count}} fragments à cette carte.",
    "duplicateYield_many": "Chaque doublon rapporte {{count}} fragments à cette carte.",
    "atLevel": "Niveau {{level}}",
    "automatic": "Auto",
    "customizeHint": "Les changements s’affichent sur ta carte en direct. Enregistre pour les garder.",
    "lockedCard": "Retire cette carte de la vente, de l’enchère ou de l’échange pour modifier son apparence.",
    "nicknameHint": "Le vrai nom reste visible pour reconnaître le personnage. {{max}} caractères maximum.",
    "signaturePlaceholder": "Ex. Mon premier coup de cœur",
    "signatureHint": "Une courte phrase au pied de ta carte. {{max}} caractères maximum.",
    "transferHint": "Ton apparence est personnelle : elle ne suit pas la carte lors d’une vente ou d’un échange. Le niveau est conservé.",
    "save": "Enregistrer le style",
    "saving": "Enregistrement…",
    "saved": "Style de carte enregistré",
    "saveFailed": "Style impossible à enregistrer",
    "invalidText": "Retire les sauts de ligne et caractères invisibles, puis réessaie.",
    "cancel": "Annuler",
    "features": {
      "nickname": "Surnom",
      "nameColor": "Couleur du nom",
      "frame": "Bordure",
      "emblem": "Emblème",
      "haloColor": "Couleur du halo",
      "finish": "Finition",
      "signature": "Signature",
      "aura": "Aura",
      "portrait": "Cadrage du portrait"
    },
    "colors": { "ice": "Glace", "cyan": "Lagon", "gold": "Or", "rose": "Rose", "mint": "Menthe", "violet": "Lilas", "peach": "Pêche" },
    "frames": { "precision": "Gravée", "duo": "Double", "ornate": "Ornement" },
    "emblems": { "star": "Étoile", "heart": "Cœur", "moon": "Lune", "flame": "Flamme", "crown": "Couronne", "sword": "Épée" },
    "finishes": { "silk": "Soie", "prism": "Prisme", "starlight": "Poussière d’étoiles" },
    "auras": { "orbit": "Orbite", "petals": "Pétales", "constellation": "Constellation" },
    "portraits": { "original": "Original", "closeup": "Gros plan", "cinematic": "Cinématique" },
    "descriptions": {
      "1": "Le portrait d’origine et l’identité de sa rareté. Ton histoire avec cette carte commence ici.",
      "2": "Donne un surnom à ton personnage, sans masquer son véritable nom.",
      "3": "Choisis l’une des 7 couleurs du nom pour donner ta touche à la carte.",
      "4": "Une bordure gravée, double ou ornée pour encadrer ton portrait.",
      "5": "Ajoute une étoile, un cœur, une lune, une flamme, une couronne ou une épée.",
      "6": "Choisis la couleur du halo autour de la carte, indépendamment de sa rareté.",
      "7": "Une finition soie, un prisme irisé ou une poussière d’étoiles.",
      "8": "Inscris une courte phrase personnelle sous le nom et le titre.",
      "9": "Anime les contours avec une orbite lumineuse, des pétales ou une constellation.",
      "10": "Ajuste le cadrage du portrait et révèle le sceau doré de la carte éveillée."
    },
    "fx": {
      "1": "Rendu original",
      "2": "Reflets nacrés au toucher",
      "3": "Facettes lumineuses",
      "4": "Gravure des contours",
      "5": "Médaillon et liserés métalliques",
      "6": "Halo lumineux",
      "7": "Voile holographique",
      "8": "Frise de collection",
      "9": "Particules d’aura",
      "10": "Sceau doré et cadre éveillé"
    }
  },
  "share": {
    "shared": "Carte partagée",
    "failed": "Partage impossible",
    "title": "Partager {{name}}",
    "linkCopied": "Lien public copié",
    "copyLink": "Copier le lien public",
    "noFriends": "Aucun ami",
    "noFriendsHint": "Ajoute des amis pour partager cette carte en message."
  },
  "card": {
    "notOwned": "pas encore obtenu",
    "owned": "obtenu",
    "level": "niveau {{level}}",
    "fragments_one": "{{count}} fragment",
    "fragments_other": "{{count}} fragments",
    "fragments_many": "{{count}} fragments",
    "levelShort": "Nv {{level}}",
    "locked": "Carte verrouillée",
    "favoriteRemove": "Retirer {{name}} des favoris",
    "favoriteAdd": "Mettre {{name}} en favori",
    "wishRemove": "Retirer {{name}} des souhaits",
    "wishAdd": "Ajouter {{name}} aux souhaits",
    "attack": "Attaque",
    "defense": "Défense",
    "combat": "attaque {{attack}}, défense {{defense}}"
  }
}
